import axios from 'axios';

const setAuthToken = token => {

    // set some axios defs
    // Relative on purpose: the same build must work on every host
    // (adhagan.mipo.co.il, dev-adhagan.mipo.co.il, the mipo5 names).
    // The backend is always served under /backend of the same domain.
    axios.defaults.baseURL = '/backend';
    axios.defaults.headers.ContentType = "application/json";

    // set token
    if (token) {
        //axios.defaults.headers.common['x-auth-token'] = token;
        axios.defaults.headers.common['authorization'] = 'Bearer ' + token;
    } else {
        //delete axios.defaults.headers.common['x-auth-token'];
        delete axios.defaults.headers.common['authorization'];
    }
}

export default setAuthToken;